import { useMedia } from 'react-use'

export function useMediaScreen() {
  const isMobile = useMedia('(max-width: 767px)')
  const isIpad = useMedia('(min-width: 768px) and (max-width: 1024px)')
  return { isMobile, isIpad }
}
